module.exports = __webpack_public_path__ + "static/clients-boonited-e058d8d11459af6f63ae4417550e401c.svg";